import React, { useContext } from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Route, Routes } from 'react-router-dom';
import { Routing } from '../../../../util/routes.util';
import PartnerActivityPane from './Panes/PartnerActivityPane';
import { Tab, Tabs } from '../../../components/Tabs';
import PartnerOverviewPane from './Panes/PartnerOverviewPane';
import { CompanyContext } from '../../../../context/CompanyContext';
import PartnerPendingPane from './Panes/PartnerPendingPane';
import { CompanyConnectionContext } from '../../../../context/CompanyConnectionContext';
import { CompanyConnectionState } from '../../../../types/companyConnection/companyConnection';
import Provider from '../../../../providers/common/Provider';

export default function PartnerSettingsScreen() {
  const { currentCompany } = useContext(CompanyContext);
  const { companyConnections } = useContext(CompanyConnectionContext);

  const pendingConnections = Array.from(companyConnections.values()).filter(
    connection => connection.state === CompanyConnectionState.pending && connection.companyId === currentCompany.id,
  );

  const isPartner = currentCompany.partner;

  return (
    <div className='content-x content-y-screen flex h-full flex-grow flex-col'>
      <div className='mb-6 grid gap-8'>
        <p className='page-title'>{t(TranslationKey.partnerPortal).singular.upper}</p>
      </div>

      <Tabs>
        {isPartner ? (
          <>
            <Tab text={t(TranslationKey.overview).singular.upper} path={Routing.partner.overview()} />
            <Tab text={t(TranslationKey.activity).singular.upper} path={Routing.partner.activity()} />
          </>
        ) : null}
        {pendingConnections.length ? (
          <Tab
            text={
              <span className='flex items-center'>
                <p>{t(TranslationKey.pending).singular.label}</p>
                <span className='ml-2 rounded-full bg-primary px-2 text-xs text-on-primary'>
                  {pendingConnections.length > 9 ? '9+' : pendingConnections.length}
                </span>
              </span>
            }
            path={Routing.partner.pending()}
          />
        ) : null}
      </Tabs>

      <Provider
        authenticationSettings
        bin
        binStatus
        containerType
        csvUploadConfiguration
        customField
        lot
        productMasterData
        scanRule
        stockLocation
        stockLocationRoleAssignment
        tag
        file
        tagRelation
        trigger
        user
        integration
        productTransaction
        container
        order
      >
        <Routes>
          <Route path='overview' element={<PartnerOverviewPane />} />
          <Route path='activity' element={<PartnerActivityPane />} />
          <Route path='pending' element={<PartnerPendingPane />} />
        </Routes>
      </Provider>
    </div>
  );
}
